<p-toast></p-toast>
<div *ngIf="viewType == 'viewOnly'" class="card mt-2 personal-details-card">
  <h5
    [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around', 'color': 'rgb(151, 42, 42)' }">
    {{ "Component Details" | translate }}
  </h5>

  <div class="sec-1">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-3">
        <label htmlFor="VendorName">{{ "NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_Name }}" pInputText id="VendorName"
          type="text" />
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="Vendor_TypeId">{{ "REGISTRATION_TYPE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_TypeId }}" pInputText id="Vendor_TypeId"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Email_ID">{{ "OFFICIAL_EMAIL_ID" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Officical_Email_ID }}" pInputText id="Email_ID"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Mobile">{{ "Mobile" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Mobile }}" pInputText id="Mobile" type="text" />
      </div>

      <div class="field col-12 md:col-12">
        <label htmlFor="DDProgNames">{{ "PROGRAMME_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDProgNames }}" pInputText id="DDProgNames"
          type="text" />
      </div>
    </div>
  </div>

  <div class="card dashboardTable mt-3">
    <p-table #addedCompTable [value]="VendorTableDataAfterFilter" [rows]="10" [paginator]="true"
      responsiveLayout="scroll" [rowHover]="true" dataKey="Mobile"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}"
      [globalFilterFields]="[
    'MI_System_Name', 'Component_Cat', 'Component', 'Component_Size', 'Price', 'CML_SrNo', 'CML_Validity', 'CML_Certificate'
    ]">
      <ng-template pTemplate="caption">
        <div class="flex p-fluid p-formgrid align-items-center justify-content-between my-0 py-0" style="display: flex; flex-wrap:wrap">
          <!-- Left side -->
          <div class="field col-12 md:col-6 flex justify-content-start my-0 py-0">
            <div class="field col-12 md:col-12 my-0 py-0">
              <div class="grid-item">
                <span>
                  <label htmlFor="selectProgram">{{'Programme Filter'| translate}}</label>
                  <p-dropdown [options]="componentMasterList" [(ngModel)]="selectedProg" optionLabel="Program_Name"
                    (onChange)="onSelectProgramme()" placeholder="{{'SELECT_A_PROGRAMME' | translate}}" appendTo="body">
                  </p-dropdown>
                </span>
              </div>
            </div>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-1 d-flex justify-content-between">
            <p-splitButton [model]="addedCompTableExport" icon="pi pi-download"
                    label="{{'' | translate}}"></p-splitButton>
          </div>
          <!-- Right side for search -->
          <div class="field col-12 md:col-4 d-flex align-items-center justify-content-end my-0 py-0">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="addedCompTable.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>{{'S_NO'| translate}}</th>
          <th pSortableColumn="MI_System_Name">{{'MI_SYSTEM'| translate}}</th>
          <th pSortableColumn="Component_Cat">{{'CATEGORY_'| translate}}</th>
          <th pSortableColumn="Component">{{'COMPONENT'| translate}}</th>
          <th pSortableColumn="Component_Size">{{'COMPONENT_SIZE'| translate}}</th>
          <th pSortableColumn="Price">{{'PRICE'| translate}}</th>
          <th pSortableColumn="CML_SrNo">{{'CML Sr No'| translate}}</th>
          <th pSortableColumn="CML_Validity">{{'CML Validity'| translate}}</th>
          <th pSortableColumn="CML_Certificate">{{'CML Certificate'| translate}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-consolidateData let-Index="rowIndex">
        <tr class="body-section">
          <td>{{ Index + 1 }}</td>
          <td>{{consolidateData?.MI_System_Name}}</td>
          <td>{{consolidateData?.Component_Cat}}</td>
          <td>{{consolidateData?.Component}}</td>
          <td>{{consolidateData?.Component_Size}}</td>
          <td>{{consolidateData.Price | currency: 'INR'}}</td>
          <td>{{consolidateData?.CML_SrNo }}</td>
          <td>{{consolidateData?.CML_Validity | date:'mediumDate'}}</td>
          <td>
            <a *ngIf="consolidateData?.CML_Certificate && consolidateData?.CML_Certificate != 'string'"
              style="cursor: pointer" icon="pi pi-eye" [href]="consolidateData?.CML_Certificate" target="_blank">
              <button pButton type="button" class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                pTooltip="View" icon="pi pi-eye"></button>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">

      </ng-template>

    </p-table>
  </div>

</div>
<div *ngIf="viewType == 'action'" class="card mt-2 personal-details-card">
  <h5
    [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around', 'color': 'rgb(151, 42, 42)' }">
    {{ "REGISTRATION_DETAILS" | translate }}
  </h5>
  <!-- <form [formGroup]="basicDetailsForm"> -->
  <div class="sec-1">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ "BASIC_INFORMATION" | translate }}</p>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="Vendor_TypeId">{{ "REGISTRATION_TYPE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_TypeId }}" pInputText id="Vendor_TypeId"
          type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="SupManNames">{{ "MANUFACTURER_SUBMANU" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.SupManNames }}" pInputText id="SupManNames"
          type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="Email_ID">{{ "OFFICIAL_EMAIL_ID" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Officical_Email_ID }}" pInputText id="Email_ID"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Mobile">{{ "Mobile" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Mobile }}" pInputText id="Mobile" type="text" />
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="VendorName">{{ "NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_Name }}" pInputText id="VendorName"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DOI">{{ "DATE_OF_INCORPORATION" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DOI }}" pInputText id="DOI" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="GST_No">{{ "GST_NO" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.GST_No }}" pInputText id="GST_No" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Address">{{ "ADDRESS" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Address }}" pInputText id="Address" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="City">{{ "CITY" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.City }}" pInputText id="City" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="State">{{ 'STATE' | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.State }}" pInputText id="State" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Country">{{ 'COUNTRY' | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Country }}" pInputText id="Country" type="text" />
      </div>
    </div>
  </div>


  <div class="sec-2">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ "BANK_DETAILS" | translate }}</p>
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="TAN_No">{{ "TAN_NO" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.TAN_No }}" pInputText id="TAN_No" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="PAN_No">{{ "PAN_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.PAN_No }}" pInputText id="PAN_No" type="text" />
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="Account_No">{{ "ACCOUNT_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Account_No }}" pInputText id="Account_No"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="IFSC_Code">{{ "IFSC_CODE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.IFSC_Code }}" pInputText id="IFSC_Code"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Bank_Name">{{ "BANK_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Bank_Name }}" pInputText id="Bank_Name"
          type="text" />
      </div>

    </div>
  </div>

  <div class="sec-1">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ 'REGISTRATION_FEES' | translate }}</p>
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="Amount">{{ "DD_AMOUNT" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Amount }}" pInputText id="Amount" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DDNumber">{{ "DD_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDNumber }}" pInputText id="DDNumber" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DDBankName">{{ "BANK_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDBankName }}" pInputText id="DDBankName"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DD_Date">{{ "DD_DATE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DD_Date | date:'mediumDate' }}" pInputText
          id="DD_Date" type="text" />
      </div>
      <div class="field col-12 md:col-12">
        <label htmlFor="DDProgNames">{{ "PROGRAMME_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDProgNames }}" pInputText id="DDProgNames"
          type="text" />
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </form> -->

  <div class="card mt-2 attachment-card">
    <div class="field col-12 md:col-12 sub-heading">
      <p>{{ 'ATTACHMENT_DETAILS' | translate }}</p>
    </div>
    <!-- <h5
        [ngStyle]="{ 'font-weight': 'bold', 'display': 'flex', 'justify-content': 'space-around', 'color': 'rgb(151, 42, 42)' }">
        {{ "ATTACHMENT_DETAILS" | translate }}
      </h5> -->
    <div class="p-fluid p-formgrid grid d-flex justify-content-between grid mt-1">
      <!-- <div class="document-list gap-1" style="display: flex; flex-wrap: wrap;"> -->
      <div class="field col-12 md:col-3" *ngFor="let item of vendorAttachmentData; let i = index">
        <!-- <div class="field col-12 md:col-3"> -->
        <label>{{ item.Doc_Type | translate }}</label>
        <p *ngIf="item.Attachments">
          <a style="cursor: pointer" [href]="item.Attachments" target="_blank">{{ 'View Doc' | translate }}</a>
        </p>

        <!-- </div> -->
      </div>
      <div>
        <p-button (click)="downloadZip()" label="Download All" icon="pi pi-download"></p-button>
      </div>
      <p class="invalid-feedback" *ngIf="vendorAttachmentData && vendorAttachmentData.length < 1">
        {{ imageError }}
      </p>
      <!-- </div> -->
    </div>
  </div>

  <div class="card" *ngIf="appStatus == 'Pending'">
    <div class="p-fluid p-formgrid grid d-flex justify-content-center">
      <div class="field col-12 md:col-3">
        <label>{{ "Select Status" }}</label>
        <p-dropdown [options]="statusList" [(ngModel)]="selectedStatus" appendTo="body"
          placeholder="{{ 'Select Status'| translate }}" optionLabel="Status" optionValue="Flag"
          (onChange)="onStatusChange($event)"></p-dropdown>
      </div>
      <div *ngIf="selectedStatus == 'Objection'" class="field col-12 md:col-3">
        <label>{{ "Objection Type" }}</label>
        <p-multiSelect [options]="objectionTypes" appendTo="body" [(ngModel)]="selectedobjections"
          placeholder="Select Objection Type" optionLabel="DocType" display="chip" [showClear]="true"></p-multiSelect>
      </div>
      <div class="field col-12 md:col-3">
        <textarea id="description" [(ngModel)]="deptRemarks" placeholder="Remarks" pInputTextarea required rows="3"
          cols="20" class="mr-3"></textarea>
      </div>
      <div class="field col-12 md:col-3">
        <br>
        <button pButton pRipple label="Submit" type="submit" (click)="onSubmit()" class="p-button-help"></button>
      </div>
    </div>
  </div>

  <div class="mt-2" style="display: flex; justify-content: center;">
    <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary"
      (click)="onClickBack()"></button>
  </div>
</div>